export { Loader as default } from "@ableco/semantic-ui-react";
import "semantic-ui-css/components/loader.css";
